import permissions from "app/permissions";
import { getPermissions } from "auth/security/securityUtils";
import {
  AutocompleteInput,
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ReferenceField,
  ReferenceInput,
  ShowButton,
  SimpleList,
  TextField,
  TextInput,
  TopToolbar,
} from "react-admin";
import SecuredComponent from "server/security/SecuredComponent";
import { checkPermission } from "server/security/utils";
import { doctoralRequests } from "api/doctoralApi";
import { MOBILE_BREAKPOINT } from "utils/constants";
import { useMediaQuery } from "@mui/material";
import { EmptyList } from "server/components";
import { settings } from "app";
import { MobileListRow } from "features/MobileListRow";

const doctoralDisciplineFilters = [
  <TextInput
    label="Име на български език"
    source="nameBg"
    style={{ width: 400 }}
    alwaysOn
  />,
  <ReferenceInput
    source="parentId"
    reference={doctoralRequests.getDoctoralDisciplinesSelect()}
    label="Главна дисциплина"
    style={{ width: 400 }}
    alwaysOn
  >
    <AutocompleteInput
      label="Главна дисциплина"
      optionText="name"
      style={{ width: 400 }}
      filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
    />
  </ReferenceInput>,
];

const ListDoctoralDisciplines = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const ListActions = hasCreate => {
    return <TopToolbar>{hasCreate && <CreateButton />}</TopToolbar>;
  };

  return (
    <List
      title="Дисциплини"
      filters={doctoralDisciplineFilters}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateDoctoralDisciplines)} />}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow fields={[{ label: "Име на български език", value: record.nameBg }]} />
          )}
          secondaryText={record => (
            <div>
              <MobileListRow fields={[{ label: "Име на английски език", value: record.nameEn }]} />
              <MobileListRow
                fields={[
                  {
                    label: "Главна дисциплина",
                    value: (
                      <ReferenceField
                        source="parentId"
                        reference={doctoralRequests.getDoctoralDisciplinesSelect()}
                        record={record}
                      >
                        <TextField source="name" />
                      </ReferenceField>
                    ),
                  },
                ]}
              />
            </div>
          )}
          tertiaryText={() => (
            <>
              <SecuredComponent permission={permissions.canUpdateDoctoralDisciplines}>
                <EditButton label="" />
              </SecuredComponent>
              <ShowButton label="" />
            </>
          )}
        />
      ) : (
        <Datagrid bulkActionButtons={false} rowClick={false}>
          <TextField source="nameBg" label="Име на български език" sortable={false} />
          <TextField source="nameEn" label="Име на английски език" sortable={false} />
          <ReferenceField
            label="Главна дисциплина"
            source="parentId"
            reference={doctoralRequests.getDoctoralDisciplinesSelect()}
          >
            <TextField source="name" />
          </ReferenceField>
          <SecuredComponent permission={permissions.canUpdateDoctoralDisciplines}>
            <EditButton />
          </SecuredComponent>
          <ShowButton />
        </Datagrid>
      )}
    </List>
  );
};

export default ListDoctoralDisciplines;
